var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInterbankIconBank(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 8,
    fill: "#2FC169"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.253 12C15.1223 12.0078 14.0406 12.4628 13.2439 13.2657C12.4471 14.0687 12 15.1545 12 16.2862V44H39.7177C40.853 43.9984 41.9413 43.5464 42.744 42.7429C43.5468 41.9394 43.9984 40.8501 44 39.7138V12H16.253ZM36.5206 35.1046L19.4794 38.1872V20.9835L36.5206 17.9009V35.1046Z",
    fill: "#0060A9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterbankIconBank);
export default __webpack_public_path__ + "static/media/interbank_icon_bank.94bb027098af007f86c6bd96b7b1ab30.svg";
export { ForwardRef as ReactComponent };